import { SecurityFrequency } from '@repo/types';

export const AllOption = {
  label: 'All',
  value: 'all',
};

export const BooleanOptions = [
  {
    label: 'Yes',
    value: '1',
  },
  {
    label: 'No',
    value: '0',
  },
];

export const UnselectableOption = {
  label: 'None',
  value: '',
};

export const SecurityFrequencyOptions = [
  {
    label: 'Monthly',
    value: SecurityFrequency.Monthly,
  },
  {
    label: 'Quarterly',
    value: SecurityFrequency.Quarterly,
  },
  {
    label: 'Semi-Annually',
    value: SecurityFrequency.SemiAnnually,
  },
  {
    label: 'Annually',
    value: SecurityFrequency.Annually,
  },
];
